import { render } from "./freesubject.vue?vue&type=template&id=c7984b56&ts=true"
import script from "./freesubject.vue?vue&type=script&lang=ts"
export * from "./freesubject.vue?vue&type=script&lang=ts"

import "./freesubject.vue?vue&type=style&index=0&id=c7984b56&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__